import { _ as _object_spread } from "@swc/helpers/_/_object_spread";
import { _ as _object_spread_props } from "@swc/helpers/_/_object_spread_props";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { BottomSheetContentLayout, MenuItem, PopoverOnHover, Row, useOverlayContext } from 'seagull';
import { Checkmark, ChevronRight } from 'seagull/icons';
import { useIsMobileForHomePage } from '~/hooks/useIsMobileForHomePage';
import { useLocaleKeys } from '~/i18n';
import { DEFAULT_LOCALE, isSupportedLocale, LOCALE_LABELS, SUPPORTED_LOCALES } from '~/i18n/locales';
import { setLocale } from '~/i18n/setLocale';
import { useIoContext } from '~/providers/IoContext';
import styles from './LanguageSwitcher.module.scss';
export const LanguageSwitcherTestIds = {
    Trigger: 'language-switcher-trigger',
    TriggerChevron: 'language-switcher-trigger-chevron',
    Option: (lang)=>"language-switcher-option-".concat(lang),
    OptionCheckmark: (lang)=>"language-switcher-option-".concat(lang, "-check")
};
export function LanguageSwitcher(param) {
    let { onCloseMenu } = param;
    const isMobileDevice = useIsMobileForHomePage();
    const { t, i18n } = useLocaleKeys('components.userMenu');
    const { cookies, locationReload } = useIoContext();
    const { pushBottomSheetPage, popBottomSheetPage, hideBottomSheet } = useOverlayContext();
    const currentLang = isSupportedLocale(i18n.language) ? i18n.language : DEFAULT_LOCALE;
    const handleSelect = (lang, closeSubmenu)=>{
        closeSubmenu();
        onCloseMenu();
        setLocale(lang, {
            cookies,
            locationReload
        });
    };
    const renderOptionList = (closeSubmenu)=>/*#__PURE__*/ _jsx("div", {
            className: styles.optionList,
            children: SUPPORTED_LOCALES.map((lang)=>/*#__PURE__*/ _jsx(MenuItem, {
                    skin: "secondary",
                    testId: LanguageSwitcherTestIds.Option(lang),
                    onClick: ()=>handleSelect(lang, closeSubmenu),
                    children: /*#__PURE__*/ _jsxs(Row, {
                        gap: 12,
                        alignItems: "center",
                        justifyContent: "space-between",
                        className: styles.option,
                        children: [
                            /*#__PURE__*/ _jsx("span", {
                                children: LOCALE_LABELS[lang]
                            }),
                            lang === currentLang && /*#__PURE__*/ _jsx("span", {
                                "data-testid": LanguageSwitcherTestIds.OptionCheckmark(lang),
                                children: /*#__PURE__*/ _jsx(Checkmark, {})
                            })
                        ]
                    })
                }, lang))
        });
    const renderMobileTrigger = ()=>/*#__PURE__*/ _jsx(MenuItem, {
            skin: "secondary",
            testId: LanguageSwitcherTestIds.Trigger,
            onClick: ()=>pushBottomSheetPage({
                    content: /*#__PURE__*/ _jsx(BottomSheetContentLayout, {
                        header: {
                            title: t.language()
                        },
                        children: renderOptionList(()=>{
                            popBottomSheetPage();
                            hideBottomSheet();
                        })
                    })
                }),
            children: /*#__PURE__*/ _jsxs(Row, {
                gap: 12,
                alignItems: "center",
                justifyContent: "space-between",
                className: styles.trigger,
                children: [
                    /*#__PURE__*/ _jsx("span", {
                        children: t.language()
                    }),
                    /*#__PURE__*/ _jsx("span", {
                        "data-testid": LanguageSwitcherTestIds.TriggerChevron,
                        children: /*#__PURE__*/ _jsx(ChevronRight, {})
                    })
                ]
            })
        });
    if (isMobileDevice) {
        return renderMobileTrigger();
    }
    return /*#__PURE__*/ _jsx(PopoverOnHover, {
        placement: "left-start",
        openStrategy: "click",
        removePadding: true,
        trigger: (triggerProps)=>/*#__PURE__*/ _jsx(MenuItem, _object_spread_props(_object_spread({
                skin: "secondary",
                testId: LanguageSwitcherTestIds.Trigger
            }, triggerProps), {
                children: /*#__PURE__*/ _jsxs(Row, {
                    gap: 12,
                    alignItems: "center",
                    justifyContent: "space-between",
                    className: styles.trigger,
                    children: [
                        /*#__PURE__*/ _jsx("span", {
                            children: t.language()
                        }),
                        /*#__PURE__*/ _jsx("span", {
                            "data-testid": LanguageSwitcherTestIds.TriggerChevron,
                            children: /*#__PURE__*/ _jsx(ChevronRight, {})
                        })
                    ]
                })
            })),
        content: (param)=>{
            let { closePopover } = param;
            return renderOptionList(closePopover);
        }
    });
}
